<template>
  <div></div>
</template>

<script>
export default {
  name: "SiteInfo",
  props: ["userToken"],
  inject: ['updateSiteInfo'],
  data() {
    const root = process.env.VUE_APP_API;
    return {
      siteName: "REECH DATABASE",
      siteUrl: root,
      termsOfUseUrl: "https://reech.co.jp/term/",
      privacyPolicyUrl: "https://reech.co.jp/privacypolicy/",
      darkLogo: require("../../../src/assets/reechlogo_white.png"),
      logo: require("../../../src/assets/reechlogo.png"),
      oemAPI: root + "/api/auth/oem",
      isOem: false
    };
  },
  async mounted() {
    await this.fetchFromSitInfo();
  },
  methods: {
    async fetchFromSitInfo() {
      if (this.userToken) {
        try {
          var params = new URLSearchParams();
          params.append("user_token", this.userToken);
          const response = await this.axios.post(this.oemAPI, params);

          if (response && response.data) {
            if (response.data.oem) {
              const oem = response.data.oem;

              if(oem.site_name && oem.site_name.trim() !== '') {
                this.siteName = oem.site_name;
              }
              if(oem.site_url && oem.site_url.trim() !== '') {
                this.siteUrl = oem.site_url;
              }
              if(oem.terms_of_use_url && oem.terms_of_use_url.trim() !== '') {
                this.termsOfUseUrl = oem.terms_of_use_url;
              }
              if(oem.privacy_policy_url && oem.privacy_policy_url.trim() !== '') {
                this.privacyPolicyUrl = oem.privacy_policy_url;
              }
              if(oem.site_logo && oem.site_logo.trim() !== '') {
                this.darkLogo = oem.site_logo;
              }
              if(oem.site_logo_right_mode && oem.site_logo_right_mode.trim() !== '') {
                this.logo = oem.site_logo_right_mode;
              } else {
                if(oem.site_logo && oem.site_logo.trim() !== '') {
                  this.logo = oem.site_logo;
                }
              }
              this.$emit('updateSiteInfo', {
                siteName: this.siteName,
                siteUrl: this.siteUrl,
                termsOfUseUrl: this.termsOfUseUrl,
                privacyPolicyUrl: this.privacyPolicyUrl,
                darkLogo: this.darkLogo,
                logo: this.logo,
                oemDarkLogo: this.darkLogo,
                oemLogo: this.logo,
                isOem: true
              });

            } else {
              // 画像をreturn内で指定するとアクセス時にチラつくのでこちらに定義
              this.$emit('updateSiteInfo', {
                siteName: this.siteName,
                siteUrl: this.siteUrl,
                termsOfUseUrl: this.termsOfUseUrl,
                privacyPolicyUrl: this.privacyPolicyUrl,
                darkLogo: this.darkLogo,
                logo: this.logo,
                logoText: "DATABASE",
                isOem: false
              });
            }
          }
        } catch (error) {
          console.error("タイトルの取得中にエラーが発生しました", error);
        }
      }
    },
  },
};
</script>